// extracted by mini-css-extract-plugin
export default {"SimpleCta":"_axU5TSkZRHVH86GTFBB"};